'use client'

import { useEffect } from 'react'

export function PwaRegister() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .catch(() => {
          console.error('[PWA] Falha ao registrar service worker')
        })
    }
  }, [])

  return null
}
